import React, { useEffect, useRef, useState } from 'react'
import { NavLink, useParams } from 'react-router';
import { apiAxios } from '../services/Api';
import * as XLSX from 'xlsx';
import { FileExcel, FilePdf } from 'react-bootstrap-icons';

function RechercheAuto() {
    const params = useParams();
    const type = params.type;
    const [items, setItems] = useState([]);
    const [tmp, setTmp] = useState(items);
    const [loading, setLoading] = useState(false);
    const [ligne, setLigne] = useState(0);
    const [avant, setAvant] = useState(10);
    const [apres, setApres] = useState(0);
    const url = "api/auto-recherche/" + type + "?";

    useEffect(() => {
        if (tmp.length) {
            tmp.forEach((item, index, arr) => {
                if (item.date && item.vehicule) {
                    const params = new URLSearchParams()
                    params.set('vehicule', item.vehicule);
                    params.set('date', item.date);
                    params.set('avant', avant);
                    params.set('apres', apres);
                    apiAxios(url + params.toString()).then(res => {
                        if (res.data && res.data.length) {
                            //item.data = res.data;
                            setItems([...items, res.data])
                            //arr[index] = item;
                        }
                    });
                }
            });
        }
    }, [tmp])

    useEffect(() => {
        //console.log(loading);
    }, [loading])

    const handleRecherche = (evt) => {
        evt.preventDefault();
        //setItems([]);
        setLigne(0)
        setLoading(true);
        console.log(loading);
        let cmp = 0;
        const elts = items;

        setItems([]);
        setTmp(elts);
        recherche(items, avant, apres, url).then(d => {
            cmp++;
            setItems([...items, d]);
            console.log(items);
            setLigne(cmp)
            if (ligne == items.length) setLoading(false);
        });
    }

    const lancer = () => {
        items.forEach(async (item, index, arr) => {
            if (item.date && item.vehicule) {
                const params = new URLSearchParams()
                params.set('vehicule', item.vehicule);
                params.set('date', item.date);
                params.set('avant', avant);
                params.set('apres', apres);
                const res = await apiAxios(url + params.toString());


                if (res.data && res.data.length) {
                    item.data = res.data;
                    arr[index] = item;
                }

            }
        });
    }

    const finTraitement = () => {

    }

    const addItem = (evt) => {
        evt.preventDefault();
        setItems([...items, { date: '2024-01-01' }]);
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const workbook = XLSX.read(event.target.result, {
                type: 'binary', cellDates: true, raw: false,
                dateNF: 'yyyy-MM-dd'
            });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const sheetData = XLSX.utils.sheet_to_json(sheet, { raw: false });
            setItems(sheetData);
        };

        reader.readAsBinaryString(file);
    };

    const updateItem = (data, index) => {
        const values = items;
        values[index] = data;
        setItems(values);
    }

    const reset = (a) => {
        setItems(a);
    }

    return (
        <div>
            <div className='d-flex justify-content-between mb-4'>
                <div>
                    Avant :
                    <input type='number' min={0} defaultValue={10} onChange={evt => setAvant(evt.target.value)} />
                    Après :
                    <input type='number' min={0} defaultValue={0} onChange={evt => setApres(evt.target.value)} />
                </div>
                <div>
                    <input type='file' onChange={handleFileUpload} />
                    <button onClick={handleRecherche}>Lancer</button>
                </div>
            </div>

            <div className='d-flex justify-content-between'>
                <div>
                    {ligne} / {items.length}
                </div>
                <div>
                    <button className='btn btn-success me-2'><FileExcel className='fs-3' /></button>
                </div>
            </div>
            <div>
                <table className='table table-striped table-hover' style={{ fontSize: 11 }}>
                    <THead />
                    <TBody items={items} updateItem={updateItem} load={loading} />
                </table>

            </div>
        </div>
    )
}

export default RechercheAuto

function Affiche({ data }) {

}

function TBody({ items, updateItem, load }) {
    const [data, setData] = useState(items);
    const [loading, setLoading] = useState(load);
    console.log(loading);
    return (
        <tbody>
            {items.map((item, i) => (<Item key={i} load={loading} item={item} index={i} onUpdate={updateItem} />))}
        </tbody>
    )
}

function Item({ item, index, onUpdate, load }) {


    const [loading, setLoading] = useState(load);
    const [element, setElement] = useState(item);

    const recherche = async () => {
        if (item.date && item.vehicule) {
            /*const params = new URLSearchParams()
            params.set('vehicule', item.vehicule);
            params.set('date', item.date);
            params.set('avant', avant);
            params.set('apres', apres);
            const res = await apiAxios(url + params.toString());


            if (res.data && res.data.length) {
                item.data = res.data;
                arr[index] = item;
            }*/

        }
    }
    useEffect(() => {
        if (loading) {
            alert("recherche " + index);
        }
    }, [loading])


    const [data, setData] = useState({ vehicule: element.vehicule, date: element.date })

    const handleChange = (evt) => {
        setData({ ...data, [evt.target.name]: evt.target.value })
        onUpdate(data, index);
    }

    if (item.data && item.data.length) {
        return (
            <>
                {element.data.map((d, i) => {
                    const declaration = d.office + " " + d.year + " " + d.number;
                    console.log("déclaration");
                    return (
                        <tr>
                            {
                                i == 0 ? (
                                    <>
                                        <td><button className='btn btn-primary'>Recherche</button></td>
                                        <td><input type='text' name='vehicule' defaultValue={element.vehicule} onChange={handleChange} /></td>
                                        <td><input type='date' name='date' defaultValue={element.date} onChange={handleChange} /></td>
                                    </>
                                )
                                    : (<td colSpan={2}></td>)
                            }

                            <td>{d.vehicule}</td>
                            <td>
                                <NavLink to={"/details/" + "zra" + "/" + declaration}>
                                    {declaration}
                                </NavLink>
                            </td>
                            <td>{d.date}</td>
                            <td>{d.importateur}</td>
                            <td>{d.nbr_a}</td>
                            <td>{d.poids_t}</td>
                            <td>{d.fob_t + d.fret_t + d.assurance_t}</td>
                            <td>{d.currency}</td>
                        </tr>
                    )
                })}
            </>
        )
    }
    return (
        <tr>
            <td><button className='btn btn-primary'>Recherche</button></td>
            <td><input type='text' name='vehicule' defaultValue={element.vehicule} onChange={handleChange} /></td>
            <td><input type='date' name='date' defaultValue={element.date} onChange={handleChange} /></td>
            <td colSpan={8}></td>
        </tr>
    )
}



function THead() {
    return (
        <thead>
            <tr>
                <th></th>
                <th>Véhicule recherché</th>
                <th>Date de référence</th>
                <th>Véhicule trouvé</th>
                <th>Déclaration</th>
                <th>Date déclaration</th>
                <th>Importateur</th>
                <th>Nombre article</th>
                <th>Poids</th>
                <th>CIF</th>
                <th>Dev.</th>
            </tr>
        </thead>
    )
}

/**
 * @param {Array} items
 * @param {int} avant - The string
 * @param {int} apres
 */
async function recherche(items, avant, apres, url) {
    items.forEach(async (item, index, arr) => {
        if (item.date && item.vehicule) {
            const params = new URLSearchParams()
            params.set('vehicule', item.vehicule);
            params.set('date', item.date);
            params.set('avant', avant);
            params.set('apres', apres);
            const res = await apiAxios(url + params.toString());


            if (res.data && res.data.length) {
                item.data = res.data;
                arr[index] = item;
            }

        }
    }, items);

    return items;
}

async function waitQuery(url) {
    return new Promise((apiAxios) => {
        setTimeout(() => {
            apiAxios(url);
        }, 2000); // Attendre 2 secondes
    });
}